import Option from './Option';
import MultiValue from './MultiValue';
import SingleValue from './SingleValue';
import ClearIndicator from './ClearIndicator';
import DropdownIndicator from './DropdownIndicator';
import MultiValueRemove from './MultiValueRemove';
export default {
  Option: Option,
  MultiValue: MultiValue,
  SingleValue: SingleValue,
  ClearIndicator: ClearIndicator,
  DropdownIndicator: DropdownIndicator,
  MultiValueRemove: MultiValueRemove
};